/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React, { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { useSelector } from "react-redux";
import Button from "../../../../components/common/Button";
import Typography from "../../../../components/common/new/Typography/Typography";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus, TEXTFIELD } from "../../../../contants";
import Appointment from "../../../../services/api/appointment";
import {
  runAfterDelay,
  toCapitalize,
  toLowerCase,
} from "../../../../utils/helper";
import LabelInputField from "../components/LabellnputField/LabelInputField";
import styles from "./SplitNewStructure.styles";
import {
  selectParentStructureName,
  selectStructureParent,
} from "../../../../redux/selectors/appointment";

function SplitNewStrucute() {
  const [structureName, setStructureName] = useState("");
  const parentStrutureName = useSelector(selectParentStructureName);
  const parentStructureLevel = useSelector(selectStructureParent);

  const alert = useContext(ToastAlertContext);
  const navigate = useNavigate();

  const { parentId, level } = useParams();

  const onBack = () => navigate(-2);

  const onSubmit = async () => {
    try {
      const formattedName = structureName
        .replace(/^\s+|\s+$/g, "")
        .replace(/\s{2,}/g, " ");

      if (!formattedName.length) {
        throw new Error("Please enter a valid name");
      }

      if (!/^[A-Za-z0-9\s_-]+$/.test(formattedName)) {
        throw new Error(
          "Name should only contain letters, numbers, spaces, underscores, and dashes"
        );
      }

      const payload = {
        parentId: Number(parentId),
        name: formattedName,
        hierarchy: level,
      };

      await Appointment.split(payload);
      alert.show("Successfully created", AlertStatus.SUCCESS);
      runAfterDelay(onBack, 2000);
    } catch (error) {
      alert.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  return (
    <Box>
      <Typography variant="title2" color="#8c8c8c" caseing="capitalize">
        Parent {parentStructureLevel}: {toLowerCase(parentStrutureName)}
      </Typography>
      <Typography mt={8} variant="title3" color="#8c8c8c" caseing="capitalize">
        Add {toLowerCase(level)} Details
      </Typography>
      <Grid item xs={12}>
        <Grid container columnSpacing={8}>
          <Grid item xs={6}>
            <LabelInputField
              required
              sideLabel={`Add ${toCapitalize(level)} Name`}
              type={TEXTFIELD}
              value={structureName}
              label={`Enter new ${toCapitalize(level)} Name`}
              onChange={(e) => {
                const sanitized = e.target.value.replace(
                  /[^A-Za-z0-9\s_-]/g,
                  ""
                );
                setStructureName(sanitized);
              }}
            />
          </Grid>
        </Grid>
        <Box style={styles.btn}>
          <Button label="Create" onClick={onSubmit} />
          <Button label="Cancel" onClick={onBack} variant="outlined" />
        </Box>
      </Grid>
    </Box>
  );
}

export default SplitNewStrucute;
